import React from 'react';
import { Box } from '@mui/material';
import { ProgramCreationProvider } from '../../../../../../components/admin3/newProgram/ProgramCreationContext';
import { ManualProgramBuilder } from '../../../../../../components/admin3/newProgram/masterclass/manual/ManualProgramBuilder';
import { useAimdHeartbeat } from '../../../aimd-v2/hooks/useAimdHeartbeat';

// Embeddable Manual builder for the Add Program modal. The modal seeds the
// builder's state (localStorage['programCreation'] — groupId, programType,
// buildMode: manual, program name) before mounting this, so the provider
// hydrates straight into the manual editor for the created group. On finish
// (publish) the builder calls onFinish instead of routing to the Members
// sub-step, so the modal can close and land back on the framework.
export const ManualEmbeddedBuilder: React.FC<{
  // The drawer-created group id. Unlike the route-based manual builder (which
  // inherits the heartbeat from ProgramCreationFlow), this embedded builder
  // doesn't sit under that flow, so it must drive its own ATC heartbeat.
  groupId?: string | null;
  // What the program is saved as: the route builders get it from their route
  // ("masterclass", "masterclass&mentorship"); here the chat's format decides it.
  // Without it a Guided Course was stored as a plain Course.
  model: 'masterclass' | 'masterclass&mentorship';
  onFinish: () => void;
  // Mirrors the editor's Program name field into the modal header live.
  onProgramNameChange?: (value: string) => void;
}> = ({ groupId, model, onFinish, onProgramNameChange }) => {
  // ATC: count active design time in the embedded manual builder. No-ops until
  // the group exists; the BE clamps each ping and stops counting at Invited.
  useAimdHeartbeat(groupId);
  return (
    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', bgcolor: '#0F0F0F' }}>
      <ProgramCreationProvider>
        <ManualProgramBuilder model={model} onFinish={onFinish} onProgramNameChange={onProgramNameChange} />
      </ProgramCreationProvider>
    </Box>
  );
};

export default ManualEmbeddedBuilder;
